import React from "react";
import { NavBar } from "../../features/NavBar/NavBar.js";
import { SideBar } from "../../features/SideBar/SideBar.js";
import "./commonComponent.css";

export const Header = () => {

  return (
    <header className="headerContainer">
      <NavBar />
    </header>
  );
};
